import { createContext, useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { api } from "@/lib/api";

// Runtime feature flags from the backend env (/api/public/config). Unknown/failed → feature hidden.
const Ctx = createContext({ loaded: false, comunidad: false });

export const FeaturesProvider = ({ children }) => {
  const [f, setF] = useState({ loaded: false, comunidad: false });
  useEffect(() => {
    api.get("/public/config")
      .then((r) => setF({ loaded: true, comunidad: r.data.comunidad_enabled === true }))
      .catch((e) => { console.error("No se pudo leer la configuración de funciones", e); setF({ loaded: true, comunidad: false }); });
  }, []);
  return <Ctx.Provider value={f}>{children}</Ctx.Provider>;
};

export const useFeatures = () => useContext(Ctx);

export const visibleNav = (items, f) => items.filter((n) => !n.feature || f[n.feature]);

export const FeatureRoute = ({ feature, children }) => {
  const f = useFeatures();
  if (!f.loaded) return null;
  return f[feature] ? children : <Navigate to="/" replace />;
};
